// config.js

const defaultBindings = {
    localConsumer: {
        tcareConnectApi: 'http://127.0.0.1:3000',
        // tcareConnectApi: 'https://connect-api-dev.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-dev.tailoredcare.org',
        connectAPI: {
            host: 'http://127.0.0.1:3000',
            scopes: ["https://devmytcareai.onmicrosoft.com/fb8b0338-1dd0-48fc-a2eb-91e2143a4aa1/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_consumer_sign_in",
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://login-dev.mytcare.ai/devmytcareai.onmicrosoft.com/B2C_1_consumer_sign_in",
                }
            },
            authorityDomain: "login-dev.mytcare.ai"
        },
        loginEndpont: 'https://login.microsoftonline.com/d1a8b045-38f4-4333-8ffb-c082abb910fc',
        redirectUrl: 'http://localhost:8080/',
        appId: 'fb8b0338-1dd0-48fc-a2eb-91e2143a4aa1',
        tenantId: 'd1a8b045-38f4-4333-8ffb-c082abb910fc',
    },
    local: {
        // tcareConnectApi: 'http://127.0.0.1:3000',
        tcareConnectApi: 'https://connect-api-dev.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-dev.tailoredcare.org',
        connectAPI: {
            host: 'http://127.0.0.1:3000',
            scopes: ["https://tcareheavyind.onmicrosoft.com/d7dc1c9d-7b7f-4f4e-b78a-fa19c084d0ac/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1A_Smart_HRD_SUSI",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://tcareheavyind.b2clogin.com/tcareheavyind.onmicrosoft.com/B2C_1A_Smart_HRD_SUSI",
                },
                editProfile: {
                    authority: "https://tcareheavyind.b2clogin.com/tcareheavyind.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "tcareheavyind.b2clogin.com"
        },
        loginEndpont: 'https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51',
        redirectUrl: 'http://localhost:8080/',
        appId: 'd7dc1c9d-7b7f-4f4e-b78a-fa19c084d0ac',
        tenantId: '0ec4d3be-d7e7-4167-8cb9-688ce1f08d51',
    },
    devConsumer: {
        tcareConnectApi: 'https://connect-api-dev.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-dev.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-dev.tailoredcare.org',
            scopes: ["https://devmytcareai.onmicrosoft.com/fb8b0338-1dd0-48fc-a2eb-91e2143a4aa1/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_consumer_sign_in",
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://login-dev.mytcare.ai/devmytcareai.onmicrosoft.com/B2C_1_consumer_sign_in",
                }
            },
            authorityDomain: "login-dev.mytcare.ai"
        },
        loginEndpont: 'https://login.microsoftonline.com/d1a8b045-38f4-4333-8ffb-c082abb910fc',
        redirectUrl: 'https://connect-dev.mytcare.ai/',
        appId: 'fb8b0338-1dd0-48fc-a2eb-91e2143a4aa1',
        tenantId: 'd1a8b045-38f4-4333-8ffb-c082abb910fc',
    },
    dev: {
        tcareConnectApi: 'https://connect-api-dev.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-dev.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-dev.tailoredcare.org',
            scopes: ["https://tcareheavyind.onmicrosoft.com/d7dc1c9d-7b7f-4f4e-b78a-fa19c084d0ac/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1A_Smart_HRD_SUSI",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://tcareheavyind.b2clogin.com/tcareheavyind.onmicrosoft.com/B2C_1A_Smart_HRD_SUSI",
                },
                editProfile: {
                    authority: "https://tcareheavyind.b2clogin.com/tcareheavyind.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "tcareheavyind.b2clogin.com"
        },
        loginEndpont: 'https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51',
        redirectUrl: 'https://connect-ui-dev.tailoredcare.org/',
        appId: 'd7dc1c9d-7b7f-4f4e-b78a-fa19c084d0ac',
        tenantId: '0ec4d3be-d7e7-4167-8cb9-688ce1f08d51',
    },
    test: {
        tcareConnectApi: 'https://connect-api-test.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-test.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-test.tailoredcare.org',
            scopes: ["https://tcaretestb2c.onmicrosoft.com/3e5be605-05e2-44e1-8fe6-8f7eec94e67b/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1A_Smart_HRD_SUSI",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1A_Smart_HRD_SUSI",
                },
                editProfile: {
                    authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "tcaretestb2c.b2clogin.com"
        },
        loginEndpont: 'https://login.microsoftonline.com/dca3f89f-1b13-44bd-a818-f5e6a98dfd00',
        redirectUrl: 'https://connect-ui-test.tailoredcare.org/',
        appId: '3e5be605-05e2-44e1-8fe6-8f7eec94e67b',
        tenantId: 'dca3f89f-1b13-44bd-a818-f5e6a98dfd00'
    },
    testConsumer: {
        tcareConnectApi: 'https://connect-api-test.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-test.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-test.tailoredcare.org',
            scopes: ["https://testmytcareai.onmicrosoft.com/f7e82ccf-f694-4910-a4d2-11d54f6bb4b7/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_consumer_sign_in",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://login-test.mytcare.ai/testmytcareai.onmicrosoft.com/B2C_1_consumer_sign_in",
                },
                editProfile: {
                    authority: "https://login-test.mytcare.ai/testmytcareai.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "login-test.mytcare.ai"
        },
        loginEndpont: 'https://login.microsoftonline.com/548dc257-89b5-401c-bd66-fea4a8338c47',
        redirectUrl: 'https://connect-test.mytcare.ai/',
        appId: 'f7e82ccf-f694-4910-a4d2-11d54f6bb4b7',
        tenantId: '548dc257-89b5-401c-bd66-fea4a8338c47'
    },
    demo: {
        demoParams: {
            lockPostalCode: true
        },
        tcareConnectApi: 'https://connect-api-test.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-test.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-test.tailoredcare.org',
            scopes: ["https://tcaretestb2c.onmicrosoft.com/3e5be605-05e2-44e1-8fe6-8f7eec94e67b/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1A_Smart_HRD_SUSI",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1A_Smart_HRD_SUSI",
                },
                editProfile: {
                    authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "tcaretestb2c.b2clogin.com"
        },
        loginEndpont: 'https://login.microsoftonline.com/dca3f89f-1b13-44bd-a818-f5e6a98dfd00',
        redirectUrl: 'https://connect-ui-demo.tailoredcare.org/',
        appId: '3e5be605-05e2-44e1-8fe6-8f7eec94e67b',
        tenantId: 'dca3f89f-1b13-44bd-a818-f5e6a98dfd00'
    },
    demoConsumer: {
        demoParams: {
            lockPostalCode: false
        },
        tcareConnectApi: 'https://connect-api-demo.mytcare.ai',
        tcareConnectIntake: 'https://connect-intake-test.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api-demo.mytcare.ai',
            scopes: ["https://mytcareai.onmicrosoft.com/b91e6ad2-a61e-41f1-8a39-e34502e17a93/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_consumer_sign_in"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://login.mytcare.ai/mytcareai.onmicrosoft.com/B2C_1_consumer_sign_in",
                }
            },
            authorityDomain: "login.mytcare.ai"
        },
        redirectUrl: 'https://connect-demo.mytcare.ai',
        appId: 'b91e6ad2-a61e-41f1-8a39-e34502e17a93',
        tenantId: '2f65a84b-3195-4b3d-a3b7-5457a471e05c'
    },
    prod: {
        tcareConnectApi: 'https://connect-api.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-prod.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api.tailoredcare.org',
            scopes: ["https://tcareai.onmicrosoft.com/288f460b-2633-4185-ae02-b4973bde304d/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1A_Smart_HRD_SUSI",
                editProfile: "B2C_1_edit_profile"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com/B2C_1A_Smart_HRD_SUSI",
                },
                editProfile: {
                    authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com/B2C_1_edit_profile"
                }
            },
            authorityDomain: "tcareai.b2clogin.com"
        },
        loginEndpont: 'https://login.microsoftonline.com/79b78283-93d8-480c-a58b-93169719474b',
        redirectUrl: 'https://connect-ui-prod.tailoredcare.org/',
        appId: '288f460b-2633-4185-ae02-b4973bde304d',
        tenantId: '79b78283-93d8-480c-a58b-93169719474b'
    },
    prodConsumer: {
        tcareConnectApi: 'https://connect-api.tailoredcare.org',
        tcareConnectIntake: 'https://connect-intake-prod.tailoredcare.org',
        connectAPI: {
            host: 'https://connect-api.tailoredcare.org',
            scopes: ["https://mytcareai.onmicrosoft.com/b91e6ad2-a61e-41f1-8a39-e34502e17a93/user_impersonation"]
        },
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_consumer_sign_in"
            },
            authorities: {
                signUpSignIn: {
                    authority: "https://login.mytcare.ai/mytcareai.onmicrosoft.com/B2C_1_consumer_sign_in",
                }
            },
            authorityDomain: "login.mytcare.ai"
        },
        redirectUrl: 'https://connect.mytcare.ai',
        appId: 'b91e6ad2-a61e-41f1-8a39-e34502e17a93',
        tenantId: '2f65a84b-3195-4b3d-a3b7-5457a471e05c'
    },
}

// TODO - need function to get env and then call new getBindings() in config.js
const getEnvironment = () => {
    return '_BUILD_ENV'   //should be replaced in buildstep https://github.com/rollup/plugins/tree/master/packages/replace
}

export const env = getEnvironment();


export const getBindings = (env = '') => {
    if (env === '') {
        env = getEnvironment()
    }
    switch (env) {
        case 'localConsumer' :
            return defaultBindings.localConsumer;
        case 'local' :
            return defaultBindings.local;
        case 'devConsumer'   :
            return defaultBindings.devConsumer;
        case 'dev'   :
            return defaultBindings.dev;
        case 'testConsumer'  :
            return defaultBindings.testConsumer;
        case 'test'  :
            return defaultBindings.test;
        case 'demoConsumer'  :
            return defaultBindings.demoConsumer;
        case 'demo' :
            return defaultBindings.demo
        case 'prod'  :
            return defaultBindings.prod;
        case 'prodConsumer'  :
            return defaultBindings.prodConsumer;
        default      :
            return defaultBindings.local;
    }
}

export default getBindings;

